import { getID } from "src/libs/utilities"
import { ALIGN, FONT_CASE, FONT_WEIGHT } from "../interfaces"

const description = (): any[] => {
    return [
        {
            id: getID("title"),
            title: "Normal", 
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Rare", 
            typography: {
                letter_spacing: 6
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Wide",
            typography: {
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BOLD,
                line_height:  0.9 
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("title"),
            title: "Fat",
            typography: {
                font: "var(--fontFamily)",
                font_weight: FONT_WEIGHT.BLACK,
                line_height:  0.9 
            },
            style: { 
                "padding": "10px 0 15px 0", 
            }, 
            beforeStyle: {},
            afterStyle: {},
        },
         
    ]
}
export default description